// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* .outlineButton:hover {\r\n    background-color: #f7f7ff !important;\r\n    color: black !important;\r\n} */", "",{"version":3,"sources":["webpack://./src/components/OutlineButton.css"],"names":[],"mappings":"AAAA;;;GAGG","sourcesContent":["/* .outlineButton:hover {\r\n    background-color: #f7f7ff !important;\r\n    color: black !important;\r\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
